<template>
  <v-text-field
    :value="value"
    :required="required"
    :label="label"
    :rules="getValidations()"
    class="app-text-field-no-border rounded-lg"
    filled
    @input="e => $emit('input', e)"
  ></v-text-field>
</template>

<script>
import {mapGetters} from "vuex"
import { isValidAccount } from "@/modules/accounts/domain/Account.js";

export default {
  name:'AccountField',
  props: {
      label: {
        type: String,
        default: '',
      }, 
      required: {
        type:Boolean, 
        default:false
      },
      value: {
        type: String,
        required: true
      },
      rules:{
        type: Array,
        default: () => []
      },
  },
  data() {
    return {
      validationRules: {
        accountFormat:  v => this.isValidAccountField(v)
      },
    };
  },
  computed:{
    ...mapGetters({currentCompany:'getCurrentCompany',
                  userData: "me/userData",}),
  },
  methods:{
      isValidAccountField(value){
        let error = isValidAccount(value, this.currentCompany, this.userData);
        return error == '' || error;
      },
      getValidations() {
        let res = this.rules;
        res.push(this.validationRules.accountFormat);
        return res;
      }
  },
};
</script>
